import { PageTitle } from '../../../../shared/components/page-components/PageTitle';

export const SettingsPageNav = (): React.ReactElement<any, any> | null => {
    return <PageTitle>Communication Settings</PageTitle>;
};
